import { useContext } from 'react'
import GlobalContext, { SettingsDto } from '../context/GlobalContext'

export function useSettings(): SettingsDto {
    const globalContext = useContext(GlobalContext)
    return globalContext?.settings
}
